import { AuthContext } from '@repo-level/core-front/contexts/auth';
import { AuthButtons } from 'components/auth/AuthButtons';
import { LanguageSwitcher } from 'components/LanguageSwitcher';
import { Logo } from 'components/Logo';
import { ScrollBlock } from 'components/ScrollBlock';
import { AddonsContext } from 'contexts/addons';
import { BonanzaContext } from 'contexts/bonanza';
import { useContext } from 'react';
import { PromoPanelsDesktop } from '../Header/PromoPanels';
import { UserPanel } from '../Header/UserPanel';
import { MenuDesktop } from '../Menu/MenuDesktop';

import { ScSidebar, ScSidebarContent } from './styles';

export const Sidebar = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { isBonanzaPromoAvailable } = useContext(BonanzaContext);

  const { isEmailConfirmationPopup, emailConfirmationPopupHeight } =
    useContext(AddonsContext);

  return (
    <ScSidebar
      emailConfirmationPopupHeight={emailConfirmationPopupHeight}
      withEmailConfirmationPopup={isEmailConfirmationPopup}
    >
      <ScrollBlock
        style={{
          height: '100vh',
          width: '176px',
          transition: 'all 0.5s ease',
        }}
      >
        <ScSidebarContent smallGap={isBonanzaPromoAvailable}>
          <Logo />
          {isAuthenticated ? <UserPanel /> : <AuthButtons />}
          <PromoPanelsDesktop />
          <div className="divider" />
          <MenuDesktop />
          <LanguageSwitcher />
        </ScSidebarContent>
      </ScrollBlock>
    </ScSidebar>
  );
};
